<template>
  <nav class="nav-mobile show-sm" role="navigation">
      <a href="#" id="" class="nav-mobile__close" @click.prevent="hideMenu()">
        <!-- <img :src="images.close" width="20" alt="close" /> -->
        <i class="fas fa-times"></i>
      </a>

      <ul class="nav nav--block nav--primary">
        <!--<li class="nav__item" v-if="$config.MAIN_WEBSITE_URL"><a :href="$config.MAIN_WEBSITE_URL" target="_blank" class="nav__link fs-sm">กลับเว็บไซต์หลัก</a></li>-->
        <li class="nav__item"><a :href="$utils.getWpPath('')" class="nav__link">หน้าแรก</a></li>
        <!-- <li class="nav__item"><a :href="$utils.getWpPath('phapaforeducation')" class="nav__link">แคมเปญ</a></li> -->
        <li class="nav__item"><router-link to="/special-events" class="nav__link">เพจระดมเงิน</router-link></li>
        <li class="nav__item"><a :href="$utils.getWpPath('our-work')" class="nav__link">งานของเรา</a></li>
        <li class="nav__item"><a :href="$utils.getWpPath('about')" class="nav__link">เกี่ยวกับเรา</a></li>
        <li class="nav__item"><a :href="$utils.getWpPath('good-governance')" class="nav__link">ธรรมาภิบาล</a></li>
        <li class="nav__item"><a :href="$utils.getWpPath('take-action')" class="nav__link">ร่วมร้อยพลัง</a></li>
        <!-- <li class="nav__item"><a :href="$utils.getWpPath('good-governance')" class="nav__link">ธรรมมาภิบาล</a></li>
        <li class="nav__item"><a :href="$utils.getWpPath('faq')" class="nav__link">ถาม-ตอบ</a></li> -->
      </ul>

      <!-- <ul v-if="!isLoggedIn" class="nav nav--block nav--secondary">
        <li class="nav__item"><router-link to="/user/login" class="nav__link">เข้าสู่ระบบ</router-link></li>
        <li class="nav__item"><router-link to="/user/register" class="nav__link">สมัครสมาชิก</router-link></li>
      </ul>
      <ul class="nav nav--block nav--secondary is-loggedin" v-else>
        <li class="nav__item"><router-link to="/orders" class="nav__link">รายการของคุณ</router-link></li>
        <li class="nav__item"><router-link to="/user/profile" class="nav__link">แก้ไข Profile</router-link></li>
        <li class="nav__item"><router-link to="/user/logout" class="nav__link">ออกจากระบบ</router-link></li>
      </ul> -->

      <!-- nav__secondary -->
      <ul class="nav nav--inline nav--secondary" v-if="!isLoggedIn">
        <li class="nav__item"><a href="#" class="nav__link" @click.prevent="$loginModal.show()">เข้าสู่ระบบ</a></li>
      </ul>

      <!-- Login section -->
      <div class="nav nav--block nav--secondary show-sm" v-if="isLoggedIn" ref="dropdown">
        <div class="">
          <ul class="nav is-loggedin">
            <li class="nav__item">{{ name }}</li>

            <li class="nav__item">
              <router-link to="/user/pages" class="nav__link">กองผ้าป่าของฉัน</router-link></li>
            <li class="nav__item">
              <router-link to="/user/profile" class="nav__link">แก้ไขข้อมูลส่วนตัว</router-link></li>
            <li class="nav__item">
              <router-link to="/user/logout" class="nav__link">ออกจากระบบ</router-link></li>
          </ul>
        </div>
      </div>

      <!-- <div class="condition">
        <router-link to="/terms" class="condition__link">Terms of service</router-link>
        <router-link to="/policy" class="condition__link">Privacy policy</router-link>
      </div> -->
    </nav>

</template>

<script>
  export default {
    name: 'NavMenu',

    data () {
      return {
        dropdownVisible: false,
        images: {
          close: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjEyLjk4MiAyMTIuOTgyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMTIuOTgyIDIxMi45ODI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8ZyBpZD0iQ2xvc2UiPgoJPHBhdGggc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkOyIgZD0iTTEzMS44MDQsMTA2LjQ5MWw3NS45MzYtNzUuOTM2YzYuOTktNi45OSw2Ljk5LTE4LjMyMywwLTI1LjMxMiAgIGMtNi45OS02Ljk5LTE4LjMyMi02Ljk5LTI1LjMxMiwwbC03NS45MzcsNzUuOTM3TDMwLjU1NCw1LjI0MmMtNi45OS02Ljk5LTE4LjMyMi02Ljk5LTI1LjMxMiwwYy02Ljk4OSw2Ljk5LTYuOTg5LDE4LjMyMywwLDI1LjMxMiAgIGw3NS45MzcsNzUuOTM2TDUuMjQyLDE4Mi40MjdjLTYuOTg5LDYuOTktNi45ODksMTguMzIzLDAsMjUuMzEyYzYuOTksNi45OSwxOC4zMjIsNi45OSwyNS4zMTIsMGw3NS45MzctNzUuOTM3bDc1LjkzNyw3NS45MzcgICBjNi45ODksNi45OSwxOC4zMjIsNi45OSwyNS4zMTIsMGM2Ljk5LTYuOTksNi45OS0xOC4zMjIsMC0yNS4zMTJMMTMxLjgwNCwxMDYuNDkxeiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='
        }
      }
    },
    created () {
      document.getElementsByTagName('body')[0].addEventListener('click', this.clickListener, false)
    },
    unmounted () {
      document.getElementsByTagName('body')[0].removeEventListener('click', this.clickListener, false)
    },
    computed: {
      isLoggedIn () {
        return this.$store.state.token
      },
      name () {
        const user = this.$store.state.user
        if (user.firstName || user.lastName) {
          return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
        } else {
          return user.email
        }
      }
    },
    methods: {
      clickListener (ev) {
        if (this.$refs.dropdown && !this.$refs.dropdown.contains(ev.target)) {
          this.dropdownVisible = false
        }
      },
      hideMenu () {
        this.$emit('hideMenu')
      },
      toggleDropdown () {
        this.dropdownVisible = !this.dropdownVisible
      },
      hideDropdown () {
        this.dropdownVisible = false
      }
    },
    watch: {
      '$route': function () {
        this.hideDropdown()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NavMenu.vue?28b6ff90